import React, { useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { convertMonthToAr, dateToString } from '../helpers/date-convert';
import {
  ServicesResult,
  AllServices,
  ServiceColumn,
  ServicesCard,
  ServicesText,
  ServicesImage,
  EHead,
  CalendarWrapper,
} from './styles/ThreeColumnServicesBlock.styled';
import LatestNewsContext from '../context/LatestNewsContext';
import NotFoundSearchMsg from './NotFoundSearchMsg';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';
import Calendar from '../assets/svg/calendar-press.svg';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function LatestNewsPaginatedContent({ data, dir }) {
  const { listing, option } = useContext(LatestNewsContext);
  const [filteredData, setFilteredData] = useState(
    data.filter((value) => new Date(value.date).getFullYear() === +option),
  );
  const [loadMore, setLoadMore] = useState(false);
  const [hasMore, setHasMore] = useState(filteredData.length > 9);
  const [news, setNews] = useState(
    filteredData.length <= 9 ? filteredData : [...filteredData.slice(0, 9)],
  );
  const isArabic = dir === 'rtl';

  const handleLoadMore = () => setLoadMore(true);

  useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = +news.length;
      const isGrater = +currentLength < +filteredData.length;
      const nextResults = isGrater ? filteredData.slice(+currentLength, +currentLength + 9) : [];
      setNews([...news, ...nextResults]);
      setLoadMore(false);
    }
  }, [loadMore, hasMore]);

  useEffect(() => {
    const filteredNews = data.filter((value) => new Date(value.date).getFullYear() === +option);
    setNews(filteredNews.length <= 9 ? filteredNews : [...filteredNews.slice(0, 9)]);
    setFilteredData(filteredNews);
  }, [option]);

  useEffect(() => {
    const isGrater = news.length < filteredData.length;
    setHasMore(isGrater);
  }, [news]);
  const { translations } = useContext(DWTCContext);

  return (
    <ServicesResult>
      <Container>
        <AllServices
          className={listing === 'grid' ? '' : 'listpress'}
          style={{ marginBottom: '2rem' }}
        >
          {isEmpty(news) ? (
            <NotFoundSearchMsg dir={dir} />
          ) : (
            news.map(({ title, url, date, description, featuredImage }) => (
              <ServiceColumn>
                <ServicesCard href={url} className="press_servicecard">
                  <ServicesText dir={dir}>
                    <time dir={dir} className="e-date">
                      <CalendarWrapper className="calendar_icon">
                        <Calendar />
                      </CalendarWrapper>
                      {isArabic ? convertMonthToAr(dateToString(date)) : dateToString(date)}
                    </time>
                    <EHead dir={dir} className="e-head">
                      <h3 dir={dir} className="e-title">
                        {title}
                      </h3>
                      <span dir={dir} className="desc">
                        {description}
                      </span>
                    </EHead>
                  </ServicesText>
                  <ServicesImage>
                    <LazyLoadImage
                      src={isEmpty(featuredImage) || featuredImage.url}
                      alt={isEmpty(featuredImage) || featuredImage.name}
                      effect="blur"
                      placeholderSrc={
                        featuredImage ? `${featuredImage.url}?width=50&quality=50` : null
                      }
                      width="100%"
                      height="100%"
                    />
                  </ServicesImage>
                </ServicesCard>
              </ServiceColumn>
            ))
          )}
        </AllServices>
      </Container>
      {hasMore && (
        <LoadMoreGenericBtn
          color="blue"
          position="center"
          label={getTranslationByKey(translations, 'Load More')}
          onClick={handleLoadMore}
          dir={dir}
        />
      )}
    </ServicesResult>
  );
}
